import { takeLatest, put, all, call } from "redux-saga/effects";
import UserActionTypes from "./user.types";
import { firestore, functions } from "../../utils/firebase/firebase.util";
import {
  fetchGemeindeStart,
  clearGemeinde,
} from "../gemeinde/gemeinde.actions";
import {
  signInSuccess,
  signInFailure,
  signOutSuccess,
  signOutFailure,
  inviteUserFailure,
  inviteUserSuccess,
  fetchUsersSuccess,
  fetchUsersFailure,
} from "./user.actions";
import {
  auth,
  createUserProfileDocument,
  getCurrentUser,
} from "../../utils/firebase/firebase.util";

function* getSnapshotFromUserAuth(userAuth) {
  try {
    const userRef = yield call(createUserProfileDocument, userAuth);
    const userSnapshot = yield userRef.get();
    const userData = yield userSnapshot.data();

    yield put(
      signInSuccess({
        id: userSnapshot.id,
        //gemeinde: gemeindeData,
        ...userData,
      })
    );
    yield put(fetchGemeindeStart(userData.gemeindeRef));
  } catch (error) {
    yield put(signInFailure(error));
  }
}

export function* signInWithEmail({ payload: { email, password } }) {
  try {
    const { user } = yield auth.signInWithEmailAndPassword(email, password);
    yield call(getSnapshotFromUserAuth, user);
  } catch (error) {
    yield put(signInFailure(error));
  }
}

export function* inviteUser({ payload: { email, displayName, gemeindeId } }) {
  try {
    const addUser = functions.httpsCallable("addUser");
    const data = {
      email: email,
      displayName: displayName,
      gemeindeId: gemeindeId,
    };
    const user = yield addUser(data).then((result) => {
      return result;
    });
    console.log(user);
    yield put(inviteUserSuccess());
    yield put(
      fetchGemeindeStart(firestore.collection("gemeinden").doc(gemeindeId))
    );
  } catch (error) {
    console.log(error);
    yield put(inviteUserFailure(error));
  }
}

export function* isUserAuthenticated() {
  try {
    const userAuth = yield getCurrentUser();
    if (!userAuth) return;
    yield call(getSnapshotFromUserAuth, userAuth);
  } catch (error) {
    yield put(signInFailure(error));
  }
}
export function* signOut({ payload }) {
  const callback = payload;
  try {
    yield auth.signOut();
    yield put(clearGemeinde());
    yield put(signOutSuccess());
    callback();
  } catch (error) {
    yield put(signOutFailure(error));
  }
}

export function* fetchUsersAsync() {
  try {
    const userRef = firestore.collection("users");
    const snapshot = yield userRef.get();
    const transformedUsers = yield snapshot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });
    yield put(fetchUsersSuccess(transformedUsers));
  } catch (error) {
    yield put(fetchUsersFailure(error));
  }
}

export function* setCurrentUserAsync({ payload }) {
  try {
    firestore
      .collection("users")
      .doc(payload.id)
      .set(payload);
  } catch (error) {
    yield put(signInFailure(error));
  }
}

export function* onEmailSignInStart() {
  yield takeLatest(UserActionTypes.EMAIL_SIGN_IN_START, signInWithEmail);
}

export function* onCheckUserSession() {
  yield takeLatest(UserActionTypes.CHECK_USER_SESSION, isUserAuthenticated);
}

export function* onSignOutStart() {
  yield takeLatest(UserActionTypes.SIGN_OUT_START, signOut);
}

export function* onRegisterNewErntehelfer() {
  yield takeLatest(UserActionTypes.INVITE_USER, inviteUser);
}

export function* onFetchUsers() {
  yield takeLatest(UserActionTypes.FETCH_USERS_START, fetchUsersAsync);
}

export function* onSetCurrentUser() {
  yield takeLatest(UserActionTypes.SET_CURRENT_USER, setCurrentUserAsync);
}

export function* userSagas() {
  yield all([
    call(onEmailSignInStart),
    call(isUserAuthenticated),
    call(onSignOutStart),
    call(onRegisterNewErntehelfer),
    call(onFetchUsers),
    call(onSetCurrentUser),
  ]);
}
